import { color } from "@smoothincorg/smooth-ui"
import Select from "react-select"
import { AssignableStore, useAssignableStoresSWR } from "src/hooks/useAssignableStoresSWR"

export const StoreSelector: React.FC<{
  value: number
  onChange: (value: number) => void
}> = ({ value, onChange }) => {
  const { assignableStoresSwr } = useAssignableStoresSWR()

  if (!assignableStoresSwr.data) return <div className="">加盟店データを読み込んでいます…</div>

  return (
    <Select
      className="basic-single"
      classNamePrefix="select"
      value={{
        value: value,
        label: assignableStoresSwr.data.stores.find((s: AssignableStore) => s.id === value)?.name,
      }}
      isSearchable
      name="storeId"
      options={assignableStoresSwr.data.stores.map((s: AssignableStore) => ({
        value: s.id,
        label: `${s.name} ${s.customerAcquisitionSupportEnabled ? "(集客支援可)" : ""}`,
      }))}
      onChange={(e) => onChange(e.value)}
      placeholder="加盟店を選択"
      styles={{
        control: (styles) => ({
          ...styles,
          backgroundColor: "white",
          border: "2px solid " + color.mediumLightGray,
          borderRadius: 8,
          fontSize: 16,
          height: 49,
          minWidth: 300,
        }),
      }}
    />
  )
}
